import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import api from 'api';
import Util from 'utility.js';
import { addMeal, addTraining, setAppModeData, setProfileData, setLectureTaskCompleteSaved } from 'actions/index';

function LectureTaskLoad() {
    const data = useSelector(state => state);
    const dispatch = useDispatch();
    const history = useHistory();
    const { id } = useParams();

    useEffect(() => {
        Util.setPageTitle('Úkol');
        const lectureId = data.appModeData.lectureId;

        let url = 'lecturetask/info/' + lectureId;
        if (data.appSubMode === 'LECTURETASK_SAMPLE') url += '?lectureTaskSample=1';

        api(url).then(result => {
            if (result.data.profile !== false) {
                dispatch(setProfileData({ id: result.data.profile.id, data: result.data.profile }));
            }
            if (result.data.profile_override !== false) {
                dispatch(setAppModeData({ profileOverride: result.data.profile_override }));
            }

            const lectureData = result.data.lecture_data;

            if (Array.isArray(lectureData.meal_types)) {
                lectureData.meal_types.forEach(m => {
                    if (m.type * 1 <= 0) return;
                    const t = m.time.split(':');
                    dispatch(addMeal({
                        mealId: m.type * 1,
                        mealLength: 0,
                        startHour: t[0] * 1,
                        startMinute: t[1] * 1,
                        profiles: [Util.getActiveProfileId()]
                    }));
                });
            }

            if (Array.isArray(lectureData.activity_types)) {
                lectureData.activity_types.forEach(a => {
                    if (a.time === '' || a.length === '') return;
                    const t = a.time.split(':');
                    dispatch(addTraining({
                        start: t[0] + ':' + t[1],
                        length: a.length,
                        description: a.title,
                        profiles: [Util.getActiveProfileId()]
                    }));
                });
            }

            api('lecturetask/load/' + id, { post: true, data: { lectureId } }).then(res => {
                if (typeof res.data.switch_to_profile === 'object') {
                    dispatch(setProfileData({ id: res.data.switch_to_profile.id, data: res.data.switch_to_profile }));
                }
                if (res.data.task_meta && res.data.task_meta.is_complete === 1) {
                    dispatch(setLectureTaskCompleteSaved(true));
                }
                history.push('/plan');
            });
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
}

export default LectureTaskLoad;
